// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3tPhK","calendarButtons":"ClockData_calendarButtons__2ch_u"};